import React from 'react';
import { Star } from 'lucide-react';
import './TestimonialsSection.css';

export default function TestimonialsSection() {
    const testimonials = [
        {
            name: 'Ismat Fatema',
            stars: 5,
            content:
                "I always have something I want customised urgently, and that’s when Handmade Haven steps in creating the most beautiful resin pieces and personalised stickers for me. The quality is always on point, exactly how I imagine it. Truly a trustworthy destination for all resin and art needs.",
        },
        {
            name: 'Sunita Christian',
            stars: 4,
            content:
                'Absolutely love the resin pieces! Everything is so well-made and unique. You can tell a lot of care and creativity goes into each item. Definitely recommend ❤',
        },
        {
            name: 'Samira Shaikh',
            stars: 5,
            content:
                'I got a resin frame made from Muskan, handmadehaven , and I absolutely loved it! The design was beautiful, and the finishing was perfect.',
        },
    ];

    return (
        <section className="testimonials-section">
            <h2 className="section-title">Customer Reviews</h2>

            <div className="testimonials-container">
                <div className="testimonials-grid">
                    {testimonials.map((t, index) => (
                        <div key={index} className="testimonial-card">
                            <div className="testimonial-stars" aria-label={`${t.stars} out of 5 stars`}>
                                {Array.from({ length: 5 }).map((_, i) => (
                                    <Star
                                        key={i}
                                        className={`star-icon ${i < t.stars ? 'star-filled' : 'star-empty'}`}
                                    />
                                ))}
                            </div>

                            <p className="testimonial-content">{t.content}</p>

                            <div className="testimonial-author">

                                <div className="author-info">
                                    <div className="author-name">{t.name}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
